import { useState, useRef } from 'react';
import { unitsViewStates, viewStates } from '../constants';
import type { BackendLesson, AssessmentFormContext, LessonTab } from '../types';

export function useLessonsPageState() {
    const [activeTab, setActiveTab] = useState<LessonTab>('create');
    const [backendLessons, setBackendLessons] = useState<BackendLesson[]>([]);
    const [unitsViewState, setUnitsViewState] = useState(unitsViewStates.loading);
    const [viewState, setViewState] = useState(viewStates.loadingCurriculum);

    // Create lesson states
    const [selectedTopics, setSelectedTopics] = useState<any[]>([]);
    const [expandedCards, setExpandedCards] = useState<Set<string>>(new Set());
    const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
    const [showCreateAssessmentForm, setShowCreateAssessmentForm] = useState<boolean>(false);
    const [assessmentFormContext, setAssessmentFormContext] = useState<AssessmentFormContext | null>(null);
    const [selectedLearningStyles, setSelectedLearningStyles] = useState<string[]>([]);
    const [showLimitDialog, setShowLimitDialog] = useState<boolean>(false);
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState<boolean>(false);
    const [curriculumData, setCurriculumData] = useState<any>(null);
    /** E308 mapped to E179-shaped tree for CurriculumLibraryTreeView (tenant custom curriculum). */
    const [tenantCustomCurriculumLibraryData, setTenantCustomCurriculumLibraryData] = useState<any>(null);
    const [studentCurriculumData, setStudentCurriculumData] = useState<any>(null);
    const [selectedCurriculum, setSelectedCurriculum] = useState<string>('');
    const [isStudentCurriculumActive, setIsStudentCurriculumActive] = useState<boolean>(true);
    const [selectedProvider, setSelectedProvider] = useState<string>('');
    const [loadedNodeIds, setLoadedNodeIds] = useState<Set<string>>(new Set());
    const [loadingNodeIds, setLoadingNodeIds] = useState<Set<string>>(new Set());
    const [loadingTopicDetails, setLoadingTopicDetails] = useState<Set<string>>(new Set());
    const [showAddTopicsDialog, setShowAddTopicsDialog] = useState<boolean>(false);
    const [showCreateYourOwnWizard, setShowCreateYourOwnWizard] = useState<boolean>(false);
    const [showCreateCustomTopicsDialog, setShowCreateCustomTopicsDialog] = useState<boolean>(false);
    const [showAddCustomTopicDialog, setShowAddCustomTopicDialog] = useState<boolean>(false);
    /** Pre-selected catalog subject when opening topic dialogs from Create Your Own wizard step 2. */
    const [wizardInitialCatalogSubjectId, setWizardInitialCatalogSubjectId] = useState<string>('');
    
    const mediumTreeviewRef = useRef<HTMLDivElement>(null);
    const lessonsPanelRef = useRef<HTMLDivElement>(null);
    const isStudentCurriculumActiveRef = useRef<boolean>(true);

    return {
        // Tab state
        activeTab,
        setActiveTab,
        
        // Units state
        backendLessons,
        setBackendLessons,
        unitsViewState,
        setUnitsViewState,
        
        // View state
        viewState,
        setViewState,
        
        // Topic selection state
        selectedTopics,
        setSelectedTopics,
        expandedCards,
        setExpandedCards,
        expandedNodes,
        setExpandedNodes,
        
        // Form state
        showCreateAssessmentForm,
        setShowCreateAssessmentForm,
        assessmentFormContext,
        setAssessmentFormContext,
        selectedLearningStyles,
        setSelectedLearningStyles,
        hasAttemptedSubmit,
        setHasAttemptedSubmit,
        
        // Dialog state
        showLimitDialog,
        setShowLimitDialog,
        showAddTopicsDialog,
        setShowAddTopicsDialog,
        showCreateYourOwnWizard,
        setShowCreateYourOwnWizard,
        showCreateCustomTopicsDialog,
        setShowCreateCustomTopicsDialog,
        showAddCustomTopicDialog,
        setShowAddCustomTopicDialog,
        wizardInitialCatalogSubjectId,
        setWizardInitialCatalogSubjectId,
        
        // Curriculum state
        curriculumData,
        setCurriculumData,
        tenantCustomCurriculumLibraryData,
        setTenantCustomCurriculumLibraryData,
        studentCurriculumData,
        setStudentCurriculumData,
        selectedCurriculum,
        setSelectedCurriculum,
        isStudentCurriculumActive,
        setIsStudentCurriculumActive,
        selectedProvider,
        setSelectedProvider,
        
        // Loading state
        loadedNodeIds,
        setLoadedNodeIds,
        loadingNodeIds,
        setLoadingNodeIds,
        loadingTopicDetails,
        setLoadingTopicDetails,
        
        // Refs
        mediumTreeviewRef,
        lessonsPanelRef,
        isStudentCurriculumActiveRef
    };
}
